module.exports = __webpack_public_path__ + "static/img/solutionDetailPic26.3fb3ecb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailPic26.png
// module id = m1I6
// module chunks = 1